import React from 'react'
import api from "../../conf/api.json"

function Transactions() {
  return (
    <div>Transactions</div>
  )
}

export default Transactions